<template>
<div class="containers">
    <div v-if="goArea == true" class="area-list">
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <div class="search-area">
            <CRow>
                <CCol sm="5">
                    <div class="autocomplete">
                        <input type="text"
                                class="form-control"
                                @click="toggleVisiblePegawaiSearch()"
                                @blur="toggleCloseVisiblePegawaiSearch()"
                                v-model="queryPegawaiSearch"
                                v-text="selectedItemPegawaiSearch ? selectedItemPegawaiSearch['text'] : ''"
                                @keydown.up="upPegawaiSearch"
                                @keydown.down="downPegawaiSearch"
                                @keydown.enter="selectItemPegawaiSearch"
                                placeholder="Pilih Pegawai"
                        >
                        <div class="popovers" v-show="visiblePegawaiSearch">
                            <div class="options" v-if="matchesPegawaiSearch.length != 0 && queryPegawaiSearch.length != 0" ref="optionsList">
                                <ul>
                                <li v-for="(match, index) in matchesPegawaiSearch"
                                    :key="index"
                                    :class="{ 'selected': (selectedPegawaiSearch == index)}"
                                    @click="itemClickedPegawaiSearch(index)"
                                    v-text="match['text']"></li>
                                </ul>
                            </div>
                            <div class="options" v-if="matchesPegawaiSearch.length == 0 && queryPegawaiSearch.length != 0">
                                Data Tidak Ditemukan
                            </div>
                            <div class="options" v-if="matchesPegawaiSearch.length == 0 && queryPegawaiSearch.length == 0">
                                Start Typing...
                            </div>
                        </div>
                    </div>
                </CCol>
                <CCol sm="5">
                    <div class="autocomplete">
                        <input type="text"
                                class="form-control"
                                @click="toggleVisibleKantorSearch()"
                                @blur="toggleCloseVisibleKantorSearch()"
                                v-model="queryKantorSearch"
                                v-text="selectedItemKantorSearch ? selectedItemKantorSearch['text'] : ''"
                                @keydown.up="upKantorSearch"
                                @keydown.down="downKantorSearch"
                                @keydown.enter="selectItemKantorSearch"
                                placeholder="Pilih Kantor"
                        >
                        <div class="popovers" v-show="visibleKantorSearch">
                            <div class="options" v-if="matchesKantorSearch.length != 0 && queryKantorSearch.length != 0" ref="optionsList">
                                <ul>
                                <li v-for="(match, index) in matchesKantorSearch"
                                    :key="index"
                                    :class="{ 'selected': (selectedKantorSearch == index)}"
                                    @click="itemClickedKantorSearch(index)"
                                    v-text="match['text']"></li>
                                </ul>
                            </div>
                            <div class="options" v-if="matchesKantorSearch.length == 0 && queryKantorSearch.length != 0">
                                Data Tidak Ditemukan
                            </div>
                            <div class="options" v-if="matchesKantorSearch.length == 0 && queryKantorSearch.length == 0">
                                Start Typing...
                            </div>
                        </div>
                    </div>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="4"></CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
                <CCol sm="2">
                    <CButton @click="moving()" type="button" class="btn btn-add">Tambah</CButton>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" @delete="deleteData" @edit="editData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
    </div>
    <div v-else class="area-edit">
        <CModal
            size="sm"
            :centered="true"
            title="Info Delete"
            color="danger"
            :show.sync="deleteModal"
            :closeOnBackdrop="false"
            >
            <p v-if="selectedItemPegawai != null && selectedItemKantor != null">Apakah anda yakin ingin menghapus {{selectedItemPegawai.text}} - {{selectedItemKantor.text}}?</p>
            <CRow>
                <CCol sm="6">
                    <CButton @click="cancelDelete()" class="btn btn-secondary w-100 text-center btn-cancel">Batal</CButton>
                </CCol>
                <CCol sm="6">
                    <CButton @click="onDelete()" class="btn btn-danger w-100 text-center btn-delete">Ya, Hapus</CButton>
                </CCol>
            </CRow>
            <template #footer-wrapper><span></span></template>
        </CModal>
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="moving()" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-input">
            <CCol sm="12">
                <CRow>
                    <CCol sm="6">
                        <label>Nama Pegawai</label>
                        <div class="autocomplete">
                            <input type="text"
                                    class="form-control"
                                    @click="toggleVisiblePegawai()"
                                    @blur="toggleCloseVisiblePegawai()"
                                    :class="{ 'is-invalid':$v.queryPegawai.$error, 'is-valid': !$v.queryPegawai.$invalid }"
                                    v-model.trim="$v.queryPegawai.$model"
                                    v-text="selectedItemPegawai ? selectedItemPegawai['text'] : ''"
                                    @keydown.up="upPegawai"
                                    @keydown.down="downPegawai"
                                    @keydown.enter="selectItemPegawai"
                                    placeholder="Pilih Pegawai"
                            >
                            <div class="popovers" v-show="visiblePegawai">
                                <div class="options" v-if="matchesPegawai.length != 0 && queryPegawai.length != 0" ref="optionsList">
                                    <ul>
                                    <li v-for="(match, index) in matchesPegawai"
                                        :key="index"
                                        :class="{ 'selected': (selectedPegawai == index)}"
                                        @click="itemClickedPegawai(index)"
                                        v-text="match['text']"></li>
                                    </ul>
                                </div>
                                <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length != 0">
                                    Data Tidak Ditemukan
                                </div>
                                <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length == 0">
                                    Start Typing...
                                </div>
                            </div>
                        </div>
                    </CCol>
                    <CCol sm="6">
                        <label>Nama Kantor</label>
                        <div class="autocomplete">
                            <input type="text"
                                    class="form-control"
                                    @click="toggleVisibleKantor()"
                                    @blur="toggleCloseVisibleKantor()"
                                    :class="{ 'is-invalid':$v.queryKantor.$error, 'is-valid': !$v.queryKantor.$invalid }"
                                    v-model.trim="$v.queryKantor.$model"
                                    v-text="selectedItemKantor ? selectedItemKantor['text'] : ''"
                                    @keydown.up="upKantor"
                                    @keydown.down="downKantor"
                                    @keydown.enter="selectItemKantor"
                                    placeholder="Pilih Kantor"
                            >
                            <div class="popovers" v-show="visibleKantor">
                                <div class="options" v-if="matchesKantor.length != 0 && queryKantor.length != 0" ref="optionsList">
                                    <ul>
                                    <li v-for="(match, index) in matchesKantor"
                                        :key="index"
                                        :class="{ 'selected': (selectedKantor == index)}"
                                        @click="itemClickedKantor(index)"
                                        v-text="match['text']"></li>
                                    </ul>
                                </div>
                                <div class="options" v-if="matchesKantor.length == 0 && queryKantor.length != 0">
                                    Data Tidak Ditemukan
                                </div>
                                <div class="options" v-if="matchesKantor.length == 0 && queryKantor.length == 0">
                                    Start Typing...
                                </div>
                            </div>
                        </div>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Expired Date</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.tglExpired.$model"
                            :class="{ 'is-invalid':$v.tglExpired.$error, 'is-valid': !$v.tglExpired.$invalid }"
                            type="date"
                        />
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
        <CRow class="area-button-submit">
            <CCol sm="12">
                <CButton @click="moving()" type="button" class="btn btn-cancel mr-2">Batal</CButton>
                <CButton v-if="tipe != 'C'" @click="goDelete()" class="btn btn-edit-delete mr-2">
                    <span>Delete</span>
                </CButton>
                <CButton @click="submitForm()" class="btn btn-edit-submit">
                    <span v-if="loading == false">Submit</span>
                    <CSpinner v-else color="default" size="sm"/>
                </CButton>
            </CCol>
        </CRow>
    </div>
</div>
</template>

<script>
import Tables from '../../../component/tablesEmployeeWorkplace'
import {DataApi} from "../../../service/DataApi";
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { ModelSelect } from 'vue-search-select'
export default {
    components: {
        Tables,
        ModelSelect
    },
    mixins: [validationMixin],
    validations: {
        queryPegawai: {
            required
        },
        queryKantor: {
            required
        },
        tglExpired: {
            required
        },
    },
    data() {
        return {
            success: true,
            itemHeight: 39,

            // data search select pegawai
            dataPegawai: [],
            titlePegawai:"Pilih Pegawai",
            selectedItemPegawai: null,
            selectedPegawai: 0,
            queryPegawai: '',
            visiblePegawai: false,
            idPegawai: '',

            // data search select kantor
            dataKantor: [],
            titleKantor:"Pilih Kantor",
            selectedItemKantor: null,
            selectedKantor: 0,
            queryKantor: '',
            visibleKantor: false,
            idKantor: '',

            // data search select pegawai
            dataPegawaiSearch: [],
            titlePegawaiSearch:"Pilih Pegawai",
            selectedItemPegawaiSearch: null,
            selectedPegawaiSearch: 0,
            queryPegawaiSearch: '',
            visiblePegawaiSearch: false,
            idPegawaiSearch: '',

            // data search select kantor
            dataKantorSearch: [],
            titleKantorSearch:"Pilih Kantor",
            selectedItemKantorSearch: null,
            selectedKantorSearch: 0,
            queryKantorSearch: '',
            visibleKantorSearch: false,
            idKantorSearch: '',

            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            dataTh: ['Nama Pegawai', 'NIP', 'Divisi', 'Jabatan', 'Nama Kantor', 'Latitude', 'Longitude','Action'],
            dataTd: ['namaPegawai', 'nik', 'bidang', 'jabatan', 'namaKantor', 'latitude', 'longitude', 'action'],
            styleTable: ['150px', '100px', '100px', '100px', '130px', '100px', '110px','100px'],
            classReload: 'reloadOff',
            goArea: true,
            loading: false,
            alertMess: '',
            currentAlertCounter: 0,
            deleteModal: false,

            // data model
            tglExpired: '',
            tipe: 'C',
            unix: '',

            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // datas
            datas: [],

            //toast
            errorMessage: '',
            flagSearch: false
        }
    },
    computed: {
        matchesPegawai() {
            if (this.queryPegawai == '') {
                return [];
            }
            return this.dataPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryPegawai.toLowerCase()))
        },
        matchesKantor() {
            if (this.queryKantor == '') {
                return [];
            }
            return this.dataKantor.filter((item) => item['text'].toLowerCase().includes(this.queryKantor.toLowerCase()))
        },
        matchesPegawaiSearch() {
            if (this.queryPegawaiSearch == '') {
                return [];
            }
            return this.dataPegawaiSearch.filter((item) => item['text'].toLowerCase().includes(this.queryPegawaiSearch.toLowerCase()))
        },
        matchesKantorSearch() {
            if (this.queryKantorSearch == '') {
                return [];
            }
            return this.dataKantorSearch.filter((item) => item['text'].toLowerCase().includes(this.queryKantorSearch.toLowerCase()))
        }
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        goArea() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        queryPegawai() {
            if(this.queryPegawai == '') {
                this.idPegawai = ''
            }
            this.getDataPegawai('null')
        },
        queryKantor() {
            if(this.queryKantor == '') {
                this.idKantor = ''
            }
            this.getDataKantor('null')
        },
        queryPegawaiSearch() {
            this.flagSearch = true
            this.getDataPegawaiSearch()
        },
        queryKantorSearch() {
            this.flagSearch = true
            this.getDataKantorSearch()
        },
    },
    methods: {
        /**
         * SEARCH SELECT PEGAWAI
         */
        getDataPegawai(val) {
            let payload = ''
            if(val == 'null') {
                payload = {
                    bidang: '',
                    jabatan: '',
                    limit: 10,
                    nama: this.queryPegawai,
                    pageIn: 1,
                    pegawaiId: '',
                    tipePegawai: ''
                }
            } else {
                payload = {
                    bidang: '',
                    jabatan: '',
                    limit: 10,
                    nama: '',
                    pageIn: 1,
                    pegawaiId: val,
                    tipePegawai: ''
                }
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataPegawai = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].idPegawai,
                        text: tempData[i].nama + ' - ' + tempData[i].nik
                    }
                    this.dataPegawai.push(onPush)
                }
                if(val != 'null') {
                    this.queryPegawai = this.dataPegawai[0].text
                    this.idPegawai = val
                }
            })
        },
        toggleVisiblePegawai() {
            this.visiblePegawai = true;
        },
        hidePegawai() {
            this.visiblePegawai = false;
        },
        toggleCloseVisiblePegawai() {
            setTimeout(this.hidePegawai, 1000);
        },
        itemClickedPegawai(index) {
            this.selectedPegawai = index;
            this.selectItemPegawai();
        },
        selectItemPegawai() {
            if (!this.matchesPegawai.length) {
            return;
            }
            this.selectedItemPegawai = this.matchesPegawai[this.selectedPegawai];
            this.visiblePegawai = false;
            this.queryPegawai = this.selectedItemPegawai.text
            this.idPegawai = this.selectedItemPegawai.value
            if (this.shouldReset) {
            this.queryPegawai = '';
            this.selectedPegawai = 0;
            }
        },
        upPegawai() {
            if (this.selectedPegawai == 0) {
            return;
            }
            this.selectedPegawai -= 1;
            this.scrollToItemPegawai();
        },
        downPegawai() {
            if (this.selectedPegawai >= this.matchesPegawai.length - 1) {
            return;
            }
            this.selectedPegawai += 1;
            this.scrollToItemPegawai();
        },
        scrollToItemPegawai() {
            this.$refs.optionsList.scrollTop = this.selectedPegawai * this.itemHeight;
        },

        /**
         * SEARCH SELECT KANTOR
         */
        getDataKantor(val) {
            let payload = ''
            if(val == 'null') {
                payload = {
                    kantorId: '',
                    kota: '',
                    limit: 10,
                    nama: this.queryKantor,
                    pageIn: 1,
                    provinsi: ''
                }
            } else {
                payload = {
                    kantorId: val,
                    kota: '',
                    limit: 10,
                    nama: '',
                    pageIn: 1,
                    provinsi: ''
                }
            }
            DataApi.post("kantor/get", payload)
            .then(res => {
                this.dataKantor = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].id,
                        text: tempData[i].nama 
                    }
                    this.dataKantor.push(onPush)
                }
                if(val != 'null') {
                    this.queryKantor = this.dataKantor[0].text
                    this.idKantor = val
                }
            })
        },
        toggleVisibleKantor() {
            this.visibleKantor = true;
        },
        hideKantor() {
            this.visibleKantor = false;
        },
        toggleCloseVisibleKantor() {
            setTimeout(this.hideKantor, 1000);
        },
        itemClickedKantor(index) {
            this.selectedKantor = index;
            this.selectItemKantor();
        },
        selectItemKantor() {
            if (!this.matchesKantor.length) {
            return;
            }
            this.selectedItemKantor = this.matchesKantor[this.selectedKantor];
            this.visibleKantor = false;
            this.queryKantor = this.selectedItemKantor.text
            this.idKantor = this.selectedItemKantor.value
            if (this.shouldReset) {
            this.queryKantor = '';
            this.selectedKantor = 0;
            }
        },
        upKantor() {
            if (this.selectedKantor == 0) {
            return;
            }
            this.selectedKantor -= 1;
            this.scrollToItemKantor();
        },
        downKantor() {
            if (this.selectedKantor >= this.matchesKantor.length - 1) {
            return;
            }
            this.selectedKantor += 1;
            this.scrollToItemKantor();
        },
        scrollToItemKantor() {
            this.$refs.optionsList.scrollTop = this.selectedKantor * this.itemHeight;
        },

        /**
         * GET DATA
         */
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.namaPegawai.toLowerCase() < b.namaPegawai.toLowerCase()) {
                        return -1
                    }
                    if (a.namaPegawai.toLowerCase() > b.namaPegawai.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.nik.toLowerCase() < b.nik.toLowerCase()) {
                        return -1
                    }
                    if (a.nik.toLowerCase() > b.nik.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 2) {
                function compare(a,b) {
                    if (a.bidang.toLowerCase() < b.bidang.toLowerCase()) {
                        return -1
                    }
                    if (a.bidang.toLowerCase() > b.bidang.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 3) {
                function compare(a,b) {
                    if (a.jabatan.toLowerCase() < b.jabatan.toLowerCase()) {
                        return -1
                    }
                    if (a.jabatan.toLowerCase() > b.jabatan.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 4) {
                function compare(a,b) {
                    if (a.namaKantor.toLowerCase() < b.namaKantor.toLowerCase()) {
                        return -1
                    }
                    if (a.namaKantor.toLowerCase() > b.namaKantor.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 5) {
                function compare(a,b) {
                    if (a.latitude.toLowerCase() < b.latitude.toLowerCase()) {
                        return -1
                    }
                    if (a.latitude.toLowerCase() > b.latitude.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 6) {
                function compare(a,b) {
                    if (a.longitude.toLowerCase() < b.longitude.toLowerCase()) {
                        return -1
                    }
                    if (a.longitude.toLowerCase() > b.longitude.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let limit = this.size
            let page = this.page

            let payload = {
                limit: limit,
                namaKantor: this.queryKantorSearch,
                pageIn: page,
                namaOrganisasi: this.queryPegawaiSearch.split(" - ")[0],
            }
            DataApi.post("pegawai/get/kantor", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        reload() {
            this.queryKantorSearch = ''
            this.idKantorSearch = ''
            this.queryPegawaiSearch = ''
            this.idPegawaiSearch = ''
            this.flagSearch = true
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },

        /**
         * ADD DATA
         */
        moving() {
            setTimeout(this.moveArea, 600);
        },
        moveArea() {
            if(this.goArea == true) {
                this.goArea = false
            } else {
                this.goArea = true
                this.queryPegawai = ''
                this.queryKantor = ''
                this.idKantor = ''
                this.idPegawai = ''
                this.unix = ''
                this.tglExpired = ''
                this.tipe = 'C'
                this.getDataPegawai('null')
                this.getDataKantor('null')
                this.$v.$reset()
            }
        },
        goSave() {
            let tipe = ''
            if(this.deleteModal == true) {
                tipe = 'D'
            } else {
                tipe = this.tipe
            }
            let idPegawai = this.idPegawai
            let idKantor = this.idKantor

            let tglExpired = ''
            let getDate = new Date()
            let year = getDate.getFullYear()
            let month = getDate.getMonth() + 1
            let date = getDate.getDate()
            if(this.tglExpired == 'null' || this.tglExpired == null || this.tglExpired == '') {
                tglExpired = year + '-' + month + '-' + date
            } else {
                tglExpired = this.tglExpired
            }
            let unix = this.unix

            let payload = {
                idKantor: idKantor,
                idPegawai: idPegawai,
                tglExpired: tglExpired,
                tipe: tipe,
                unix: unix
            }
            DataApi.post("pegawai/save/kantor", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.deleteModal = false
                this.getData()
                this.moving()
                this.loading = false
                this.currentAlertCounter = 7
            })
        },
        /**
         * EDIT DATA
         */
        editData(value) {
            let generate = this.datas[value]
            this.unix = generate.unix
            this.getDataPegawai(generate.idPegawai)
            this.getDataKantor(generate.idKantor)
            if(generate.tglExpired == null || generate.tglExpired == 'null') {
                this.tglExpired = ''
            } else {
                this.tglExpired = generate.tglExpired
            }
            this.tipe = 'u'
            this.moving()
        },

        /**
         * VALIDATE DATA
         */
        submitForm() {
            this.$v.$touch()
            if(this.$v.$invalid) {
                //
            } else {
                this.goSave()
                this.loading = true
            }
        },
        goDelete() {
            this.deleteModal = true
        },
        onDelete() {
            this.goSave()
        },
        cancelDelete() {
            this.deleteModal = false
        },

        /**
         * SEARCH SELECT PEGAWAI SEARCH
         */
        getDataPegawaiSearch() {
            let payload = {
                bidang: '',
                jabatan: '',
                limit: 10,
                nama: this.queryPegawaiSearch,
                pageIn: 1,
                pegawaiId: '',
                tipePegawai: ''
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataPegawaiSearch = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].idPegawai,
                        text: tempData[i].nama + ' - ' + tempData[i].nik
                    }
                    this.dataPegawaiSearch.push(onPush)
                }
            })
        },
        toggleVisiblePegawaiSearch() {
            this.visiblePegawaiSearch = true;
        },
        hidePegawaiSearch() {
            this.visiblePegawaiSearch = false;
        },
        toggleCloseVisiblePegawaiSearch() {
            setTimeout(this.hidePegawaiSearch, 1000);
        },
        itemClickedPegawaiSearch(index) {
            this.selectedPegawaiSearch = index;
            this.selectItemPegawaiSearch();
        },
        selectItemPegawaiSearch() {
            if (!this.matchesPegawaiSearch.length) {
            return;
            }
            this.selectedItemPegawaiSearch = this.matchesPegawaiSearch[this.selectedPegawaiSearch];
            this.visiblePegawaiSearch = false;
            this.queryPegawaiSearch = this.selectedItemPegawaiSearch.text
            this.idPegawaiSearch = this.selectedItemPegawaiSearch.value
            if (this.shouldReset) {
            this.queryPegawaiSearch = '';
            this.selectedPegawaiSearch = 0;
            }
        },
        upPegawaiSearch() {
            if (this.selectedPegawaiSearch == 0) {
            return;
            }
            this.selectedPegawaiSearch -= 1;
            this.scrollToItemPegawaiSearch();
        },
        downPegawaiSearch() {
            if (this.selectedPegawaiSearch >= this.matchesPegawaiSearch.length - 1) {
            return;
            }
            this.selectedPegawaiSearch += 1;
            this.scrollToItemPegawaiSearch();
        },
        scrollToItemPegawaiSearch() {
            this.$refs.optionsList.scrollTop = this.selectedPegawaiSearch * this.itemHeight;
        },

        /**
         * SEARCH SELECT KANTOR
         */
        getDataKantorSearch() {
            let payload = {
                kantorId: '',
                kota: '',
                limit: 10,
                nama: this.queryKantorSearch,
                pageIn: 1,
                provinsi: ''
            }
            DataApi.post("kantor/get", payload)
            .then(res => {
                this.dataKantorSearch = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].id,
                        text: tempData[i].nama 
                    }
                    this.dataKantorSearch.push(onPush)
                }
            })
        },
        toggleVisibleKantorSearch() {
            this.visibleKantorSearch = true;
        },
        hideKantorSearch() {
            this.visibleKantorSearch = false;
        },
        toggleCloseVisibleKantorSearch() {
            setTimeout(this.hideKantorSearch, 1000);
        },
        itemClickedKantorSearch(index) {
            this.selectedKantorSearch = index;
            this.selectItemKantorSearch();
        },
        selectItemKantorSearch() {
            if (!this.matchesKantorSearch.length) {
            return;
            }
            this.selectedItemKantorSearch = this.matchesKantorSearch[this.selectedKantorSearch];
            this.visibleKantorSearch = false;
            this.queryKantorSearch = this.selectedItemKantorSearch.text
            this.idKantorSearch = this.selectedItemKantorSearch.value
            if (this.shouldReset) {
            this.queryKantorSearch = '';
            this.selectedKantorSearch = 0;
            }
        },
        upKantorSearch() {
            if (this.selectedKantorSearch == 0) {
            return;
            }
            this.selectedKantorSearch -= 1;
            this.scrollToItemKantorSearch();
        },
        downKantorSearch() {
            if (this.selectedKantorSearch >= this.matchesKantorSearch.length - 1) {
            return;
            }
            this.selectedKantorSearch += 1;
            this.scrollToItemKantorSearch();
        },
        scrollToItemKantorSearch() {
            this.$refs.optionsList.scrollTop = this.selectedKantorSearch * this.itemHeight;
        },
    },
    mounted() {
        this.getDataPegawaiSearch()
        this.getDataKantorSearch()
        this.getDataPegawai('null')
        this.getDataKantor('null')
        this.errorMessage = 'Find Your Data'
    },
}
</script>
<style scoped>
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
@media screen and (min-width: 1253px) and (max-width: 1358px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1168px) and (max-width: 1252px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1097px) and (max-width: 1167px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1036px) and (max-width: 1096px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 992px) and (max-width: 1035px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1359px){
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}

.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}

.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}

.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select, .area-input .autocomplete {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.btn-edit-delete {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:red;
    color: white;
    font-size: 14px;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}

.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
</style>
